import {formattaImporto, getDataFormattata} from "../../../../../../utility/common";
import NsDataTable from "../../../../../../components/tabelle/NsDataTable";

export default function TabellaMovimentiCertificatoView({
                                                            movimenti,
                                                        }) {

    return (
        <NsDataTable
            data={movimenti}
            columns={[
                {
                    name: 'ID',
                    selector: row => row.id_movimento,
                    sortable: true,
                },
                {
                    name: 'Data',
                    selector: row => getDataFormattata(row.data_movimento),
                    sortable: true,
                },
                {
                    name: 'Tipo',
                    selector: row => <span
                        className={row.id_tipo_movimento === 'VERSAMENTO' ? 'ns-span--verde' : 'ns-span--rosso'}>{row.tipo_movimento}</span>,
                    sortable: true,
                },
                {
                    name: 'Importo',
                    selector: row => '€ ' + formattaImporto(row.importo),
                    sortable: true,
                },
                {
                    name: 'Conto',
                    selector: row => row.conto,
                    sortable: true,
                },
                {
                    name: 'Causale',
                    selector: row => row.causale_movimento && row.causale_movimento !== '' ? row.causale_movimento : row.id_causale_movimento,
                    sortable: true,
                },
                {
                    name: 'Riferimento persona',
                    selector: row => row.nominativo,
                    sortable: true,
                },
                {
                    name: 'Riferimento fattura',
                    selector: row => row.rif_fattura,
                    sortable: true,
                },
                {
                    name: 'Note',
                    selector: row => row.note,
                    sortable: true,
                },
                {
                    name: 'RFI / Abarth',
                    selector: row => row.abarth == '1' ?
                        <span className={"rfi-etichetta rfi-etichetta--arancione"}>Abarth</span>
                        : <span className={"rfi-etichetta rfi-etichetta--blu"}>RFI</span>,
                    sortable: true,
                }
            ]}
            addPagination={false}
            addFiltri={false}
        />
    );

}